import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=d2c0e34a"
import script from "./Publicity.vue?vue&type=script&lang=ts"
export * from "./Publicity.vue?vue&type=script&lang=ts"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=d2c0e34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports